import { I18nData } from '@/store/use-translation-store';

export function TranslationHandler(ast: Ast, resAst: Ast) {
  const watchFaceName = ast.attrsMap.name.split('@')[1];
  const { children } = resAst;
  const i18n: I18nData = {
    translations: {},
    locales: []
  };
  children
    .filter((item) => item.tag === 'Translation')
    .forEach((item) => {
      let key = '';
      item.attrsMap.name === watchFaceName
        ? (key = 'watchfaceName')
        : (key = item.attrsMap.name);
      const tempObj: {
        [key: string]: string;
      } = {};
      item.children.forEach((item) => {
        const { language, str } = item.attrsMap;
        tempObj[language] = str;
        if (!i18n.locales.includes(language as 'en_US')) {
          i18n.locales.push(language as 'en_US');
        }
      });
      i18n.translations[key] = tempObj;
    });
  return i18n;
}
